import safeDivide from 'lumen/utils/numeric/safe-divide';

export function calculateAdr(
  roomRevenue: number,
  roomNights: number,
): number | null {
  return safeDivide(roomRevenue, roomNights);
}

export function calculateNetAdr(
  netRevenue: number,
  roomNights: number,
): number | null {
  return safeDivide(netRevenue, roomNights);
}

export function calculateAverageCostPerRoomNight(
  cost: number,
  roomNights: number,
): number | null {
  return safeDivide(cost, roomNights);
}

export function calculateCostToRoomRevenueRatio(
  cost: number,
  roomRevenue: number,
): number | null {
  return safeDivide(cost, roomRevenue);
}

export function calculateNetRevenueToRoomRevenueRatio(
  netRevenue: number,
  roomRevenue: number,
): number | null {
  return safeDivide(netRevenue, roomRevenue);
}

export function calculateOccupancyRate(
  roomNights: number,
  capacity: number,
): number | null {
  return safeDivide(roomNights, capacity);
}

export function calculateRelativeChange(
  current: number,
  comparison: number | null | undefined,
): number | null {
  if (comparison === null || comparison === undefined || comparison === 0) {
    return null;
  }
  return safeDivide(current - comparison, comparison);
}
